import { useT } from "./i18n";

export function TermsPage() {
  const t = useT();

  return (
    <div className="min-h-screen px-6 py-16 max-w-2xl mx-auto">
      <a
        href="/"
        className="text-sm text-[var(--color-text-muted)] hover:text-[var(--color-text)] mb-12 inline-block"
      >
        &larr; {t("backHome")}
      </a>

      <h1 className="text-3xl font-bold mb-8">{t("terms")}</h1>
      <p className="text-sm text-[var(--color-text-muted)] mb-10">
        {t("lastUpdated")}
      </p>

      <div className="space-y-8 text-[var(--color-text-muted)] leading-relaxed">
        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("termsIntroTitle")}</h2>
          <p>{t("termsIntro")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("termsGameDataTitle")}</h2>
          <p>{t("termsGameData")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("termsVirtualTitle")}</h2>
          <p>{t("termsVirtual")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("termsSubscriptionTitle")}</h2>
          <p>{t("termsSubscriptionIntro")}</p>
          <ul className="list-disc list-inside mt-3 space-y-1">
            <li>{t("termsSubscriptionMonthly")}</li>
            <li>{t("termsSubscriptionLifetime")}</li>
          </ul>
          <p className="mt-3">{t("termsSubscriptionAutoRenew")}</p>
          <p className="mt-3">{t("termsSubscriptionManage")}</p>
          <p className="mt-3">{t("termsSubscriptionRestore")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("termsDisclaimerTitle")}</h2>
          <p>{t("termsDisclaimer")}</p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-[var(--color-text)] mb-3">{t("contactUs")}</h2>
          <p>
            {t("termsContact")}
            <a href="mailto:dreamcontinue.cd@icloud.com">dreamcontinue.cd@icloud.com</a>
          </p>
        </section>
      </div>

      <footer className="mt-16 pt-8 border-t border-[var(--color-border)] text-sm text-[var(--color-text-muted)]">
        {t("copyright")}
      </footer>
    </div>
  );
}
